module.exports = __webpack_public_path__ + "media/bootstrap-icons/display-18cd8cfd.svg";